var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2966 2.79834H2.85855C2.16061 2.79834 1.59375 3.3652 1.59375 4.06314V14.7353C1.59375 15.4332 2.16061 16.0001 2.85855 16.0001H10.2966C10.9945 16.0001 11.5614 15.4332 11.5614 14.7353V4.06314C11.5581 3.3652 10.9913 2.79834 10.2966 2.79834ZM10.6734 14.732C10.6734 14.9417 10.503 15.1121 10.2933 15.1121H2.85527C2.64556 15.1121 2.47518 14.9417 2.47518 14.732V4.06314C2.47518 3.85343 2.64556 3.68304 2.85527 3.68304H10.2933C10.503 3.68304 10.6734 3.85343 10.6734 4.06314V14.732Z",
    fill: "#04BA96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1403 0H5.7023C5.00436 0 4.4375 0.566864 4.4375 1.2648C4.4375 1.51055 4.6341 1.70715 4.87985 1.70715C5.1256 1.70715 5.3222 1.51055 5.3222 1.2648C5.3222 1.05509 5.49259 0.884702 5.7023 0.884702H13.1403C13.3501 0.884702 13.5204 1.05509 13.5204 1.2648V11.9369C13.5204 12.1466 13.3501 12.317 13.1403 12.317C12.8946 12.317 12.698 12.5136 12.698 12.7594C12.698 13.0051 12.8946 13.2017 13.1403 13.2017C13.8383 13.2017 14.4051 12.6349 14.4051 11.9369V1.2648C14.4051 0.566864 13.8383 0 13.1403 0Z",
    fill: "#04BA96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.6b7e6a96d6d6fce3fafa36434d396bed.svg";
export { ForwardRef as ReactComponent };